import { caseSensitiveTransform as n } from "./case-sensitive-transform.js";
function s(e, r) {
  return n(e, r.toLowerCase());
}
export {
  s as caseInsensitiveTransform
};
//# sourceMappingURL=case-insensitive-transform.js.map
